import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { contactData } from '../mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { name: 'Home', id: 'home' },
    { name: 'About', id: 'about' },
    { name: 'Services', id: 'services' },
    { name: 'Projects', id: 'projects' },
    { name: 'Contact', id: 'contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <button
            onClick={() => scrollToSection('home')}
            className="flex flex-col group"
          >
            <span
              className={`text-2xl font-light tracking-[0.3em] transition-colors ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              SHRI
            </span>
            <span
              className={`text-xs tracking-[0.4em] font-light transition-colors ${
                isScrolled ? 'text-gray-600' : 'text-white/80'
              }`}
            >
              ENTERPRISE
            </span>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className={`text-sm tracking-wider uppercase transition-colors relative group ${
                  isScrolled
                    ? 'text-gray-700 hover:text-gray-900'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link.name}
                <span className="absolute bottom-0 left-0 w-0 h-px bg-current transition-all duration-300 group-hover:w-full" />
              </button>
            ))}
          </nav>

          {/* Contact Info */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href={`tel:${contactData.phone[0]}`}
              className={`flex items-center gap-2 text-sm transition-colors ${
                isScrolled
                  ? 'text-gray-700 hover:text-gray-900'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              <Phone className="w-4 h-4" />
              <span className="hidden xl:inline">{contactData.phone[0]}</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 transition-colors ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <nav className="flex flex-col px-4 py-6 gap-4">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="text-left text-gray-700 hover:text-gray-900 text-sm tracking-wider uppercase py-2 border-b border-gray-100 last:border-0"
              >
                {link.name}
              </button>
            ))}
            <div className="flex flex-col gap-3 pt-4 border-t">
              <a
                href={`tel:${contactData.phone[0]}`}
                className="flex items-center gap-2 text-sm text-gray-700"
              >
                <Phone className="w-4 h-4" />
                {contactData.phone[0]}
              </a>
              <a
                href={`mailto:${contactData.email}`}
                className="flex items-center gap-2 text-sm text-gray-700"
              >
                <Mail className="w-4 h-4" />
                {contactData.email}
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};